import { useCallback, useEffect, useState } from 'react';
import { shouldFetchData, status } from '../../../data/fetchStatus';
import { addTransition, resizeElement } from '../../../utils/accordeon';
import Services from '../../Services/services';

function ClientDocuments({ documents, id }) {
	const [documentLinks, setDocumentLinks] = useState(undefined);

	const [linksFetched, setLinksFetched] = useState(status.DEFAULT);

	const fetchDocumentsLinks = useCallback(async () => {
		if (linksFetched === status.FETCHED) return;

		setLinksFetched(status.FETCHED);

		try {
			const keyList = [];
			const documentsList = [];

			console.log('fetch download links', documents?.length);

			documents.forEach((document) => {
				if (document?.uploadedBy === 'client') {
					documentsList.push({
						name: document.name,
						downloadLink: '',
					});
					keyList.push(document.fileKey);
				}
			});

			if (keyList.length === 0) return;

			const fileUrlList = await Services.documentService.fileListById(keyList);

			fileUrlList.forEach(
				(url, idx) => (documentsList[idx].downloadLink = url)
			);

			setDocumentLinks(documentsList);

			// Refresh links after 1 hour (time in milliseconds)
			setTimeout(() => setLinksFetched(status.REFRESH), 3600000);
		} catch (error) {
			console.error(error);
		}
	}, [documents, linksFetched]);

	useEffect(() => {
		if (
			documents !== null &&
			documents !== undefined &&
			documents.length !== 0
		) {
			if (shouldFetchData(linksFetched)) fetchDocumentsLinks();
		}
	}, [documents, linksFetched, fetchDocumentsLinks]);

	function switchAccordion(e) {
		const accordionBtnElm = e.target;
		const { accordionbtn } = accordionBtnElm.dataset;

		const accordionElm = document.querySelector(
			`[data-accordion=${accordionbtn}]`
		);

		if (!accordionElm) return;

		if (accordionBtnElm.classList.contains('active')) {
			accordionElm.style.maxHeight = '0px';
			accordionBtnElm.classList.remove('active');
		} else {
			accordionBtnElm.classList.add('active');
			resizeElement(accordionBtnElm, accordionElm);

			const containerElm = document.getElementById(id);
			const targetElm = containerElm.getElementsByClassName(
				'element-details-open'
			)[0];
			addTransition(containerElm, targetElm, 100, 500);
		}
	}

	return (
		<>
			{documentLinks !== undefined && (
				<div className="client-contract-history">
					<button
						className="contract-history-header"
						data-accordionbtn={`client-document-${id}`}
						onClick={(e) => switchAccordion(e)}
					>
						<span className="history-header-title">Documents clients</span>
						<span className="history-header-arrow"></span>
					</button>
					<div
						className="contract-history-accordion"
						data-accordion={`client-document-${id}`}
					>
						{documentLinks !== undefined &&
							documentLinks.map((document, index) => (
								<a
									key={document.name}
									href={document.downloadLink}
									download={document.name}
									className="client-documents-item"
									target="_blank"
									rel="noreferrer"
								>
									{document.name}
								</a>
							))}
					</div>
				</div>
			)}
		</>
	);
}
export default ClientDocuments;
